import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';



import { ContratosGestaoService } from '../../../../../providers/contratos-gestao-service';
import { AlertService } from '../../../../../providers/alert-service';
import { MenuService } from '../../../../../providers/menu-service';
import { ModulosController } from '../../../modulos-controller';
import { UsuarioService } from '../../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../../providers/gestao-pca-service';

@Component({
    selector: 'page-servidores-contemplados-pagamentos',
    templateUrl: 'servidores-contemplados-pagamentos.html',
    providers: [
        ContratosGestaoService
    ]
})

export class ServidoresContempladosPagamentosPage extends ModulosController {
    @ViewChild('myInput') myInput: ElementRef;

    listaDados: any = [];
    loading: boolean = true;
    submetendoNoCertificado: boolean = false;
    idSecaoPagina: string = "152";

    page: number = 1;

    order: string = 'nome';
    reverse: boolean = true;

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public contratosGestaoService: ContratosGestaoService,
        public gestaoPcaService: GestaoPcaService,
        private menuService: MenuService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
        this.carregarDados();
        this.setModuloId(14);
    }

    setOrder(value: string) {
        if (this.order === value) {
            this.reverse = false;
            this.order = "-" + value;
        } else {
            this.reverse = true;
            this.order = value;
        }
    }

    carregarDados() {
        this.contratosGestaoService.listarServidoresPagamentos().subscribe(data => {
            this.listaDados = data;
            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    voltarParaContratosGestao() {
        this.menuService.redirecionarPagina(this.contratosGestaoService.obterIdPaginaContratosGestao());
    }

    salvarFlagIncluir(enviarMensagem = true) {
        this.loading = true;
        this.listaDados.resultadoAnalise = this.capitalize(this.listaDados.resultadoAnalise);
        this.contratosGestaoService.salvarServidoresPagamentos(this.listaDados).subscribe(data => {
            if (enviarMensagem) {
                this.alertService.mostraAlerta("", "Salvo com sucesso.");
                this.loading = false;
            }
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
            this.loading = false;
        })
    }

    submeterNoCertificado() {
        this.loading = true;
        if (this.listaDados.resultadoAnalise.replace(/^\s+|\s+$/g, '') == "" || this.listaDados.resultadoAnalise == null || this.listaDados.resultadoAnalise == undefined || !this.listaDados.resultadoAnalise) {
            this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
            this.loading = false;
        } else {
            if (this.listaDados) {
                this.listaDados.resultadoAnalise = this.capitalize(this.listaDados.resultadoAnalise);
                this.contratosGestaoService.finalizarServidoresPagamentos(this.listaDados).subscribe(data => {
                    this.alertService.mostraAlerta("", "Submetido com sucesso.");
                    this.voltarParaContratosGestao();
                }, error => {
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
                    this.loading = false;
                });
            }
        }
    }

    truncateText(text) {
        let numberOfWordsToTruncate = 10;

        if (text != undefined) {
            let separatedByWords = text.split(" ");

            if (this.needTruncate(text)) {
                return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
            }
            else {
                return text;
            }
        }
    }

    needTruncate(text) {
        let separatedByWords = text.split(" ");
        let numberOfWordsToTruncate = 10;

        return separatedByWords.length >= numberOfWordsToTruncate;
    }

    exibirCompleto(text) {
        this.alertService.mostraAlerta('', text);
    }

    formatarZeroEsquerda(valor) {
        return valor.replace(/^0+(?!\.|$)/, '');
    }

    capitalize(str) {
        let retorno = "";

        if (str) {
            retorno = str.charAt(0).toUpperCase() + str.slice(1);
        }

        return retorno;
    }

    cpf_mask(v) {
        if(v){
            v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
            v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
            v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
            //de novo (para o segundo bloco de números)
            v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
            return v;
        }
    }

    cnpj_mask(v) {
        if(v){
            v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
            v = v.replace(/(\d{2})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
            v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
            //de novo (para o segundo bloco de números)
            v = v.replace(/(\d{3})(\d)/, '$1/$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
            v = v.replace(/(\d{4})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
            return v;
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/contratos-gestao/analista/servidores-contemplados-pagamentos/servidores-contemplados-pagamentos.ts